module.exports = __webpack_public_path__ + "static/apple-icon-152x152-b49cd83c884bcd44f157b7ce6274bdf2.png";